module.exports = __webpack_public_path__ + "images/emoji/princess.8f05247578f8e4c2e093.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/princess.png
// module id = iKQr
// module chunks = 1